import { action, observable, makeObservable } from 'mobx'
import * as CONST from '@voicekey/components-base/message/Message.const'
import get from 'lodash/get'
export const SEVERITIES = CONST.SEVERITIES

export class MessagesStore {
  constructor (rootStore) {
    makeObservable(this, {
      _message: observable,
      setMessage: action
    })

    this.rootStore = rootStore
  }

  _message = null

  get message () {
    return this._message
  }

  set message (value) {
    this._message = value
  }

  setMessage (message = null, severity = SEVERITIES.ERROR) {
    this.message = message ? {
      mainMessage: this.extractMessage(message),
      info: this.extractMessage(message.info),
      tooltip: get(message, ['info', 'response', 'data', 'message']),
      severity
    } : null
  }

  extractMessage (notFormattedMessage) {
    if (notFormattedMessage) {
      let messageId
      if (notFormattedMessage.response) {
        const externalLoginPagePath = window.appSettings?.externalLoginPagePath || ''
        if (externalLoginPagePath && (notFormattedMessage.response.status === 401 || notFormattedMessage.response.status === 403)) {
          window.location.replace(externalLoginPagePath)
        } else {
          if (notFormattedMessage.response.data.reason === 'SESSION_INVALID_OR_EXPIRED') {
            this.rootStore.sessionStore.resetSession()
          }
          if (notFormattedMessage.response.data.reason === 'TOKEN_INVALID_OR_EXPIRED') {
            this.rootStore.configuratorStoreSettings.resetSession()
          }
          messageId = notFormattedMessage.response.data.reason || ''
        }
      } else {
        messageId = notFormattedMessage.message || notFormattedMessage.id || notFormattedMessage.key || notFormattedMessage
      }
      return {
        id: messageId,
        defaultMessage: notFormattedMessage.defaultMessage,
        values: notFormattedMessage.values
      }
    }
    return null
  }
}
